import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const MobileNavBar = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Hide on scroll down, show on scroll up - more app-like behavior
  useEffect(() => {
    const controlNavbar = () => {
      if (typeof window !== 'undefined' && !isMenuOpen) {
        if (window.scrollY > lastScrollY && window.scrollY > 100) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
        setLastScrollY(window.scrollY);
      }
    };

    window.addEventListener('scroll', controlNavbar);
    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [lastScrollY, isMenuOpen]);

  // Close menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const navItems = [
    { name: 'Início', path: '/', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill' },
    { name: 'Sobre Nós', path: '/sobre', icon: 'ri-information-line', activeIcon: 'ri-information-fill' },
    { name: 'Voos', path: '/voos', icon: 'ri-flight-takeoff-line', activeIcon: 'ri-flight-takeoff-fill', highlight: true },
    { name: 'Seguros', path: '/seguro-viagem', icon: 'ri-shield-check-line', activeIcon: 'ri-shield-check-fill' },
    { name: 'Menu', path: '#menu', icon: 'ri-menu-5-line', activeIcon: 'ri-menu-5-fill', isMenu: true },
  ];

  const menuItems = [
    { name: 'Seguro de Viagem', path: '/seguro-viagem', icon: 'ri-shield-check-line' },
    { name: 'Corporativo', path: '/corporativo', icon: 'ri-building-line' },
    { name: 'Contactos', path: '/contacto', icon: 'ri-customer-service-2-line' },
    { name: 'Área do Cliente', path: '/area-cliente', icon: 'ri-user-line' },
  ];

  return (
    <>
      {/* Mobile Menu Drawer */}
      <div 
        className={`lg:hidden fixed inset-0 z-[110] transition-all duration-500 ${
          isMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div 
          className="absolute inset-0 bg-black/40 backdrop-blur-sm"
          onClick={() => setIsMenuOpen(false)}
        ></div>
        <div 
          className={`absolute bottom-0 left-0 right-0 liquid-glass rounded-t-[40px] p-8 transition-transform duration-500 ease-out ${
            isMenuOpen ? 'translate-y-0' : 'translate-y-full'
          }`}
        >
          <div className="w-12 h-1.5 bg-gray-300/50 rounded-full mx-auto mb-8"></div>
          <h2 className="text-xl font-bold text-gray-800 mb-6">Menu Principal</h2>
          <div className="grid grid-cols-2 gap-4">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="flex flex-col items-center justify-center p-4 rounded-3xl bg-white/50 border border-white/50 hover:bg-white/80 transition-all active:scale-95"
              >
                <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center mb-3">
                  <i className={`${item.icon} text-2xl text-primary`}></i>
                </div>
                <span className="text-sm font-medium text-gray-700">{item.name}</span>
              </Link>
            ))}
          </div>
          <button 
            onClick={() => setIsMenuOpen(false)}
            className="w-full mt-8 py-4 rounded-2xl bg-gray-100 text-gray-600 font-bold active:scale-95 transition-all"
          >
            Fechar
          </button>
        </div>
      </div>

      <div 
        className={`lg:hidden fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] w-[92%] max-w-md transition-all duration-500 ease-in-out ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0'
        }`}
      >
        <nav className="liquid-glass rounded-[28px] p-2 flex items-center justify-between gap-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            
            if (item.highlight) {
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className="liquid-glass-highlight relative flex flex-col items-center justify-center w-16 h-16 rounded-full text-white transition-all duration-300"
                >
                  <i className={`${isActive ? item.activeIcon : item.icon} text-2xl liquid-glass-icon`}></i>
                  <span className="text-[10px] font-bold mt-0.5">{item.name}</span>
                  {isActive && (
                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-white rounded-full border-2 border-primary animate-pulse"></span>
                  )}
                </Link>
              );
            }

            const handleClick = (e: React.MouseEvent) => {
              if (item.isMenu) {
                e.preventDefault();
                setIsMenuOpen(true);
              }
            };

            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={handleClick}
                className={`flex-1 flex flex-col items-center justify-center py-2 rounded-2xl transition-all duration-300 ${
                  isActive || (item.isMenu && isMenuOpen) ? 'text-primary liquid-glass-active' : 'text-gray-500 hover:text-primary'
                }`}
              >
                <i className={`${(isActive || (item.isMenu && isMenuOpen)) ? item.activeIcon : item.icon} text-xl liquid-glass-icon`}></i>
                <span className={`text-[10px] mt-1 font-medium ${(isActive || (item.isMenu && isMenuOpen)) ? 'opacity-100' : 'opacity-70'}`}>
                  {item.name}
                </span>
              </Link>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default MobileNavBar;
